// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bfd15d66","455":"7db50264","977":"15d8aa78"}[chunkId] + ".chunk.js";
};